import {getUserToken} from '@/functions.js'
import {getServerApi} from '../../config/deployment'

let envUri = getServerApi()
let contractUri = envUri+'/api/documents/contracts'


export const downloadContract = (contractNameInBucket) => {
  return getUserToken()
    .then(token => {
        var url = contractUri + "?contractName="+contractNameInBucket+"&token="+token
        window.open(url)
    })

}


// WEBPACK FOOTER //
// ./src/contracts/services/contractService.js